import { Union } from "./fable_modules/fable-library.3.7.20/Types.js";
import { union_type } from "./fable_modules/fable-library.3.7.20/Reflection.js";
import { now, compare } from "./fable_modules/fable-library.3.7.20/Date.js";
import { now as now_1 } from "./fable_modules/fable-library.3.7.20/DateOffset.js";

export class DateStatus extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Ongoing", "EndsInFuture", "StartsInFuture", "Ended", "Unknown"];
    }
}

export function DateStatus$reflection() {
    return union_type("DateUtils.DateStatus", [], DateStatus, () => [[], [], [], [], []]);
}

export function DateTime_$007CStartsInFuture$007C_$007C(startDate, endDateOpt) {
    if (compare(startDate, now()) > 0) {
        return startDate;
    }
    else {
        return void 0;
    }
}

export function DateTime_$007CEnded$007C_$007C(startDate, endDateOpt) {
    if (endDateOpt == null) {
        return void 0;
    }
    else {
        const endDate = endDateOpt;
        if (compare(endDate, now()) < 0) {
            return endDate;
        }
        else {
            return void 0;
        }
    }
}

export function DateTime_$007CEndsInFuture$007C_$007C(startDate, endDateOpt) {
    if (endDateOpt == null) {
        return void 0;
    }
    else {
        const endDate = endDateOpt;
        if ((compare(now(), startDate) > 0) && (compare(endDate, now()) > 0)) {
            return startDate;
        }
        else {
            return void 0;
        }
    }
}

export function DateTime_$007COngoing$007C_$007C(startDate, endDateOpt) {
    if (endDateOpt == null) {
        if (compare(startDate, now()) < 0) {
            return startDate;
        }
        else {
            return void 0;
        }
    }
    else {
        const endDate = endDateOpt;
        if ((compare(startDate, now()) < 0) && (compare(endDate, now()) > 0)) {
            return startDate;
        }
        else {
            return void 0;
        }
    }
}

export function DateTimeOffset_$007CStartsInFuture$007C_$007C(startDate, endDateOpt) {
    if (compare(startDate, now_1()) > 0) {
        return startDate;
    }
    else {
        return void 0;
    }
}

export function DateTimeOffset_$007CEnded$007C_$007C(startDate, endDateOpt) {
    if (endDateOpt == null) {
        return void 0;
    }
    else {
        const endDate = endDateOpt;
        if (compare(endDate, now_1()) < 0) {
            return endDate;
        }
        else {
            return void 0;
        }
    }
}

export function DateTimeOffset_$007CEndsInFuture$007C_$007C(startDate, endDateOpt) {
    if (endDateOpt == null) {
        return void 0;
    }
    else {
        const endDate = endDateOpt;
        if ((compare(now_1(), startDate) > 0) && (compare(endDate, now_1()) > 0)) {
            return startDate;
        }
        else {
            return void 0;
        }
    }
}

export function DateTimeOffset_$007COngoing$007C_$007C(startDate, endDateOpt) {
    if (endDateOpt == null) {
        if (compare(startDate, now_1()) < 0) {
            return startDate;
        }
        else {
            return void 0;
        }
    }
    else {
        const endDate = endDateOpt;
        if ((compare(startDate, now_1()) < 0) && (compare(endDate, now_1()) > 0)) {
            return startDate;
        }
        else {
            return void 0;
        }
    }
}

export function DateTimeOffset_getDateStatus(dateOffset1, dateOffset2) {
    const matchValue = [dateOffset1, dateOffset2];
    if (DateTimeOffset_$007CStartsInFuture$007C_$007C(matchValue[0], matchValue[1]) != null) {
        return new DateStatus(2);
    }
    else if (DateTimeOffset_$007CEndsInFuture$007C_$007C(matchValue[0], matchValue[1]) != null) {
        return new DateStatus(1);
    }
    else if (DateTimeOffset_$007COngoing$007C_$007C(matchValue[0], matchValue[1]) != null) {
        return new DateStatus(0);
    }
    else if (DateTimeOffset_$007CEnded$007C_$007C(matchValue[0], matchValue[1]) != null) {
        return new DateStatus(3);
    }
    else {
        return new DateStatus(4);
    }
}

